<template>
  <div id="app">
    <router-view/>
    <vue-snotify></vue-snotify>
  </div>
</template>
<script>

import ConstDef from './share//ConstDef'
import koMessages from './language/ko.json'
import { locale, loadMessages } from 'devextreme/localization'

export default {
  name: 'main-app',
  data: function () {
    return {
      isLogined: false
    }
  },
  created () {
    if (this.$route.path !== '/main' && this.$route.path !== '/') {
      const url = decodeURI(this.$route.path)
      console.log(url)
      this.$router.replace(url)
    }
    loadMessages(koMessages)
    locale(navigator.language)

    let arr = window.location.host.split(':')
    let host = window.location.protocol + '//' + arr[0]
    const port = window.location.port

    if (process.env.NODE_ENV === 'production') {
      const port = window.location.port
      ConstDef.apiUrl = `${host}:${port}${ConstDef.apiUrlProduction}`
      ConstDef.manualUrl = host + ConstDef.manualUrlProduction
      ConstDef.stompUrl = `${host}:${port}${ConstDef.stompPortProduction}`
      ConstDef.authUrl = ConstDef.authUrlProduction
    } else {
      ConstDef.apiUrl = ConstDef.apiUrlEvaluation
      if (port === '4201') {
        ConstDef.apiUrl = `${host}${ConstDef.apiUrlEvaluationLocal}`
      }
      ConstDef.manualUrl = host + ConstDef.manualUrlEvaluation
      ConstDef.stompUrl = `${host}${ConstDef.stompPortEvaluation}`
      ConstDef.authUrl = ConstDef.authUrlEvaluation
    }
  },
  mounted () {

  },
  beforeDestroy: function () {

  },
  methods: {

  }
}
</script>

<style lang="scss">
#app {
  height:100%;
  .snotify{
    width:330px;
  }
}
.dx-button-text{
  font-size:0.9rem;
}

</style>
